import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Avatar, Box, IconButton, Tooltip, Typography } from "@material-ui/core";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";
import VisibilityIcon from "@material-ui/icons/Visibility";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import ChatIcon from "@material-ui/icons/Chat";
import EventIcon from "@material-ui/icons/Event";
import EmailIcon from "@material-ui/icons/Email";
import AssignmentIcon from "@material-ui/icons/Assignment";

const CH = {
  whatsapp:  { Icon: WhatsAppIcon,  color: "#25D366" },
  instagram: { Icon: InstagramIcon, color: "#E1306C" },
  facebook:  { Icon: FacebookIcon,  color: "#1877F2" },
};

const PAL = ["#6366f1","#0ea5e9","#10b981","#f59e0b","#ef4444","#8b5cf6","#14b8a6","#f97316"];

function sc(str) {
  let h = 0;
  for (let i = 0; i < (str || "").length; i++) h = (str.charCodeAt(i) + ((h << 5) - h)) | 0;
  return PAL[Math.abs(h) % PAL.length];
}

function ab(n) {
  return (n || "?").split(" ").slice(0, 2).map(w => w[0] || "").join("").toUpperCase() || "?";
}

function cname(c) {
  const n = c?.name || "";
  return !n || /^\+?\d[\d\s\-()+]+$/.test(n.replace(/\s/g, "")) ? "Sem nome" : n;
}

function clip(s, n) {
  const t = (s || "").trim();
  return t.length > n ? t.slice(0, n) + "…" : t;
}

const useStyles = makeStyles(() => ({
  card: {
    width: "100%",
    minHeight: 138,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    background: "#fff",
    borderRadius: 10,
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    borderLeft: "4px solid transparent",
    marginBottom: 8,
    overflow: "hidden",
    transition: "box-shadow .15s, transform .12s",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
      transform: "translateY(-1px)",
    },
  },
  body: {
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
    padding: "10px 11px 0",
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
    "&:hover": { backgroundColor: "#fafafa" },
  },
  r1: {
    height: 32,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    gap: 6,
    overflow: "hidden",
    marginBottom: 5,
  },
  av: { width: 32, height: 32, fontSize: 11, fontWeight: 700, flexShrink: 0 },
  nw: { flex: 1, minWidth: 0, overflow: "hidden" },
  nm: {
    fontSize: 12, fontWeight: 700, color: "#0f172a", lineHeight: "1.25",
    whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
  },
  mt: {
    fontSize: 10, color: "#94a3b8", lineHeight: "1.25",
    whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
    marginTop: 1,
  },
  ico: {
    width: 22, height: 22, borderRadius: 6, flexShrink: 0,
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  r2: {
    height: 14,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    gap: 4,
    overflow: "hidden",
    marginBottom: 5,
  },
  ph: {
    fontSize: 11, color: "#64748b", lineHeight: "1",
    whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
    flex: 1,
  },
  r3: {
    height: 24,
    flexShrink: 0,
    background: "#f8fafc",
    borderRadius: 6,
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  },
  ms: {
    fontSize: 11, color: "#64748b", fontStyle: "italic",
    whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
    width: "100%",
  },
  foot: {
    height: 36,
    flexShrink: 0,
    borderTop: "1px solid #f1f5f9",
    display: "flex",
    alignItems: "center",
    gap: 2,
    padding: "0 8px",
  },
  btn: { width: 24, height: 24, borderRadius: 6, padding: 0, flexShrink: 0 },
  ua: {
    width: 22, height: 22, fontSize: 9, fontWeight: 700,
    marginLeft: "auto", flexShrink: 0,
  },
  tagsRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 3,
    padding: "5px 0 3px",
  },
  tag: {
    display: "inline-block",
    padding: "1px 6px",
    borderRadius: 10,
    fontSize: 9,
    fontWeight: 700,
    color: "#fff",
    lineHeight: "14px",
    whiteSpace: "nowrap",
    maxWidth: 80,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

export default function KanbanCard({ ticket, onOpenTicketDetail, onOpenSchedule, onOpenChat, onOpenDetails, onOpenEmail, onOpenHistory }) {
  const cls = useStyles();
  if (!ticket) return null;

  const contact = ticket.contact || {};
  const ch  = CH[(ticket.channel || "whatsapp").toLowerCase()] || CH.whatsapp;
  const Ico = ch.Icon;
  const name  = cname(contact);
  const phone = contact.number || "—";
  const msg   = clip(ticket.lastMessage, 55) || "Sem mensagem";
  const queue = ticket.queue && ticket.queue.name;
  const u     = ticket.user;
  const normalTags = (ticket.tags || []).filter(function(t) { return !t.kanban; }).slice(0, 5);

  const sp = fn => e => { e.stopPropagation(); if (fn) fn(); };

  return (
    <Box className={cls.card} style={{ borderLeftColor: ch.color }}>
      <Box className={cls.body}
        style={{ cursor: "pointer" }}
        onClick={function() { if (onOpenTicketDetail) onOpenTicketDetail(ticket); }}
      >

        {/* linha 1: avatar + nome + badge canal */}
        <Box className={cls.r1}>
          <Avatar src={contact.profilePicUrl || contact.urlPicture}
            className={cls.av} style={{ backgroundColor: sc(name) }}>
            {ab(name)}
          </Avatar>
          <Box className={cls.nw}>
            <Typography className={cls.nm} title={name}>{name}</Typography>
            <Typography className={cls.mt}>#{ticket.id}{queue ? ` · ${queue}` : ""}</Typography>
          </Box>
          <Box className={cls.ico} style={{ background: ch.color + "1a" }}>
            <Ico style={{ fontSize: 13, color: ch.color }} />
          </Box>
        </Box>

        {/* linha 2: telefone */}
        <Box className={cls.r2}>
          <Ico style={{ fontSize: 11, color: ch.color, flexShrink: 0 }} />
          <Typography className={cls.ph}>{phone}</Typography>
        </Box>

        {/* linha 3: última mensagem */}
        <Box className={cls.r3}>
          <Typography className={cls.ms}>{msg}</Typography>
        </Box>

        {/* etiquetas normais */}
        {normalTags.length > 0 && (
          <Box className={cls.tagsRow}>
            {normalTags.map(function(tag) {
              return (
                <span key={tag.id} className={cls.tag} style={{ backgroundColor: tag.color || "#94a3b8" }}>
                  {tag.name}
                </span>
              );
            })}
          </Box>
        )}

      </Box>

      {/* rodapé */}
      <Box className={cls.foot}>
        <Tooltip title="Detalhes do ticket">
          <IconButton size="small" className={cls.btn}
            style={{ color: "#3b82f6", background: "#eff6ff" }}
            onClick={sp(() => onOpenTicketDetail && onOpenTicketDetail(ticket))}>
            <VisibilityIcon style={{ fontSize: 12 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Etiquetas">
          <IconButton size="small" className={cls.btn}
            style={{ color: "#f59e0b", background: "#fffbeb" }}
            onClick={sp(() => onOpenDetails && onOpenDetails(ticket))}>
            <LocalOfferIcon style={{ fontSize: 12 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Abrir chat">
          <IconButton size="small" className={cls.btn}
            style={{ color: "#10b981", background: "#ecfdf5" }}
            onClick={sp(() => onOpenChat && onOpenChat(ticket))}>
            <ChatIcon style={{ fontSize: 12 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Agendar">
          <IconButton size="small" className={cls.btn}
            style={{ color: "#8b5cf6", background: "#f5f3ff" }}
            onClick={sp(() => onOpenSchedule && onOpenSchedule(contact.id))}>
            <EventIcon style={{ fontSize: 12 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title={contact.email ? "Enviar e-mail" : "Sem e-mail cadastrado"}>
          <span>
            <IconButton size="small" className={cls.btn}
              style={{ color: contact.email ? "#0ea5e9" : "#cbd5e1", background: contact.email ? "#e0f2fe" : "#f8fafc" }}
              disabled={!contact.email}
              onClick={sp(() => onOpenEmail && onOpenEmail(ticket))}>
              <EmailIcon style={{ fontSize: 12 }} />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Histórico do atendimento">
          <IconButton size="small" className={cls.btn}
            style={{ color: "#64748b", background: "#f1f5f9" }}
            onClick={sp(() => onOpenHistory && onOpenHistory(ticket))}>
            <AssignmentIcon style={{ fontSize: 12 }} />
          </IconButton>
        </Tooltip>

        {u
          ? <Tooltip title={u.name || "Atendente"}>
              <Avatar className={cls.ua} style={{ backgroundColor: sc(u.name || "") }} src={u.profileImage}>
                {ab(u.name || "")}
              </Avatar>
            </Tooltip>
          : <Box style={{ marginLeft: "auto" }} />
        }
      </Box>
    </Box>
  );
}
